import { render, staticRenderFns } from "./SLCTrackerBoard.vue?vue&type=template&id=2bf2470c&"
import script from "./SLCTrackerBoard.vue?vue&type=script&lang=ts&"
export * from "./SLCTrackerBoard.vue?vue&type=script&lang=ts&"
import style0 from "./SLCTrackerBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
